/**
 * BillingAccountAPI
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { PeriodInterval } from '../model/periodInterval';
import { ProblemDetails } from '../model/problemDetails';
import { TotalRevenueCardDto } from '../model/totalRevenueCardDto';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class TransactionGraphService {

    protected basePath = '/';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * 
     * 
     * @param merchantAuthId 
     * @param periodInterval 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiTransactionGraphGetGet(merchantAuthId?: string, periodInterval?: PeriodInterval, observe?: 'body', reportProgress?: boolean): Observable<TotalRevenueCardDto>;
    public apiTransactionGraphGetGet(merchantAuthId?: string, periodInterval?: PeriodInterval, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<TotalRevenueCardDto>>;
    public apiTransactionGraphGetGet(merchantAuthId?: string, periodInterval?: PeriodInterval, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<TotalRevenueCardDto>>;
    public apiTransactionGraphGetGet(merchantAuthId?: string, periodInterval?: PeriodInterval, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {



        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (merchantAuthId !== undefined && merchantAuthId !== null) {
            queryParameters = queryParameters.set('merchantAuthId', <any>merchantAuthId);
        }
        if (periodInterval !== undefined && periodInterval !== null) {
            queryParameters = queryParameters.set('periodInterval', <any>periodInterval);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<TotalRevenueCardDto>('get',`${this.basePath}/api/TransactionGraph/Get`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
